export default __webpack_public_path__ + "fd87dfca2fe23023c5b97606acdb06c3.svg";